<template>
  <form
    id="pay_form"
    name="pay_form"
    action="https://newpayment-test.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0"
    method="post"
  >
    <input type="hidden" name="Version" id="Version" :value="config.Version" />
    <input
      type="hidden"
      name="AccessType"
      id="AccessType"
      :value="config.AccessType"
    />
    <input type="hidden" name="AcqCode" id="AcqCode" :value="config.AcqCode" />
    <input type="hidden" name="MerId" id="MerId" :value="config.MerId" />
    <input
      type="hidden"
      name="MerOrderNo"
      id="MerOrderNo"
      :value="config.MerOrderNo"
    />
    <input
      type="hidden"
      name="TranDate"
      id="TranDate"
      :value="config.TranDate"
    />
    <input
      type="hidden"
      name="TranTime"
      id="TranTime"
      :value="config.TranTime"
    />
    <input
      type="hidden"
      name="OrderAmt"
      id="OrderAmt"
      :value="config.OrderAmt"
    />
    <input
      type="hidden"
      name="TranType"
      id="TranType"
      :value="config.TranType"
    />
    <input
      type="hidden"
      name="BusiType"
      id="BusiType"
      :value="config.BusiType"
    />
    <input type="hidden" name="CurryNo" id="CurryNo" :value="config.CurryNo" />
    <input
      type="hidden"
      name="MerPageUrl"
      id="MerPageUrl"
      :value="config.MerPageUrl"
    />
    <input
      type="hidden"
      name="MerBgUrl"
      id="MerBgUrl"
      :value="config.MerBgUrl"
    />
    <input
      type="hidden"
      name="CommodityMsg"
      id="CommodityMsg"
      :value="config.CommodityMsg"
    />
    <input type="hidden" name="MerResv" id="MerResv" :value="config.MerResv" />
    <input
      type="hidden"
      name="Signature"
      id="Signature"
      :value="config.Signature"
    />
    <div class="wrapper buy-wrapper">
      <input
        class="J-btn-submit btn mj-submit btn-strong btn-larger btn-block"
        type="submit"
        value="跳转中..."
        ref="btn"
      />
    </div>
  </form>
</template>

<script>
export default {
  name: "PayForm",
  props: ["config"],
  data() {
    return {};
  },
  methods: {
    goPay() {
      this.$nextTick(() => {
        this.$refs.btn.click();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
#pay_form
  display none
</style>
